import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import type { RootState } from 'src/store/types';

export type AuthStatus = 'unauthenticated' | 'authenticating' | 'authenticated' | 'expired';

interface AuthState {
  status: AuthStatus;
}

const initialState: AuthState = {
  status: 'unauthenticated',
};

export const globalReset = createAction('app/reset');

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthStatus(state, action: PayloadAction<AuthStatus>) {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(globalReset, () => initialState);
  },
});

export const { setAuthStatus } = authSlice.actions;
export default authSlice.reducer;

export const selectAuthStatus = (state: RootState): AuthStatus => state.auth.status;
export const selectIsAuthenticated = (state: RootState): boolean =>
  state.auth.status === 'authenticated';
